import { render } from "./ConfinedSpaceHeader.vue?vue&type=template&id=cb2f91be&scoped=true"
import script from "./ConfinedSpaceHeader.vue?vue&type=script&lang=js"
export * from "./ConfinedSpaceHeader.vue?vue&type=script&lang=js"

import "./ConfinedSpaceHeader.vue?vue&type=style&index=0&id=cb2f91be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2f91be"]])

export default __exports__